import moment from "moment";
import TextField from "../../../../../components/fields/textField/TextField.vue";
import {
  SnackBarModule
} from "../../../../../modules/SnackBarModule";
import {
  FeriadoCivilService
} from "../../../../../services/FeriadoCivilService";
export default {
  name: "EditarFeriado",

  components: {
    TextField,
  },

  props: {
    selected: {
      required: true
    },
    isOpen:{
      required:true
    }
  },

  data: () => ({
    form: {},

    loading: {
      btn: false,
    }
  }),

  beforeMount() {
    this.initializeForm();
    this.$forceUpdate();
  },

  watch: {
    isOpen: function (isOpen) {
      if (isOpen) {
        this.initializeForm();
      }
    }

  },

  methods: {

    initializeForm() {
      this.form = {
        id: this.selected.id,
        nome: this.selected.nome,
        data: moment(this.selected.data).format("YYYY-MM-DD")
      };
      this.$forceUpdate();
    },
    prepareForm() {
      if (this.$refs.form.validate()) {
        const formData = new FormData()
        formData.append("nome", this.form.nome);
        formData.append("data", moment(this.form.data).format("YYYY-MM-DD"))
        formData.append("id_tipo_feriado", 2)

        return this.editarFeriado(formData);
      }
      return SnackBarModule("Campo(s) obrigatório(s) não informado(s).", "error");
    },

    async editarFeriado(formData) {
      this.loading.btn = true;
      const response = await FeriadoCivilService.editarFeriado(formData, this.form.id);
      if (response) {
        this.$refs.form.reset();
      }
      this.loading.btn = false;
      this.$emit("on-close");

    },

    close() {
      this.$emit("on-close");
    },

  },
};